// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","mainText":"Gda9d5e"};